import React from "react";
import { Container, Row, Col } from "react-bootstrap";
// import PlayVideo from "../Play/PlayVideo";

import CTABtnModule from "gatsby-theme-starberry-lomondgroup/src/modules/cta_btn_module";
import ContentModule from "gatsby-theme-starberry-lomondgroup/src/modules/content_module";
import ImageModule from "gatsby-theme-starberry-lomondgroup/src/modules/image_module";
import PlayVideo from "gatsby-theme-starberry-lomondgroup/src/modules/video_module/PlayVideo";

import {RenderComponent} from "gatsby-theme-starberry-lomondgroup/src/modules/render-component";

import "gatsby-theme-starberry-lomondgroup/src/components/Customer/Customer.scss";
import { isEmpty } from "lodash";

const Customer = ({Module, GQLPage, office_template, areaguide_template}) => {

    const renderComponent = RenderComponent()

    let [isPlay, setPlay] = React.useState(false);
    let [isReadMore, setReadMore] = React.useState(false);

    //console.log("Module customer ==>", Module)

    var videoUrl = Module?.embed_video_url ? Module?.embed_video_url : "";


    var imagename = "pages.video_section_image.video_image";

    if(office_template){
        imagename = "office.video_section_image.video_image"
    }
    if(areaguide_template){
        imagename = "area-guides.video_section_image.video_image"
    }

    var full_wdth_img = "" ;
    
    //console.log("module_image ", Module?.title, (isEmpty(Module?.title) && isEmpty(Module?.content)))

    if(isEmpty(Module?.title) && isEmpty(Module?.content)){
        imagename = "pages.video_section_image.full_wdth_image"
        full_wdth_img = "full_wdth"
    } else{
        full_wdth_img = ""
    }

    let processedImages = JSON.stringify({});
    if (GQLPage?.imagetransforms?.video_section_image_Transforms) {
        processedImages = GQLPage?.imagetransforms?.video_section_image_Transforms;
    }

    const [searchQuery, setSearchQuery] = React.useState("");

    const handleSearch = () => {
        if (searchQuery.trim() !== "") {
            window.location.href = `/branch-finder/?q=${encodeURIComponent(searchQuery)}`;
        } else {
            window.location.href = `/branch-finder/`;
        }
    };

    return (
        <React.Fragment>
            <section className={`customer ${Module?.vid_img_align} ${Module?.title ? Module?.title.toLowerCase().replace(/ /g, '_') : ""} ${Module?.bg_color} ${Module?.vid_layout_type} ${Module?.cust_padd}`}>

                {Module?.vid_layout_type === "image_fixed_height" && 
                    <div className={`video-img ${full_wdth_img}`}>
                        {Module?.image?.url && renderComponent === "true" &&
                            <ImageModule ImageSrc={Module.image} altText={Module?.title} imagetransforms={processedImages} ggfx_results={GQLPage?.ggfx_results} renderer="srcSet" imagename={imagename} strapi_id={GQLPage?.id} />  
                        }

                        {videoUrl && 
                        <button className="video-wrap"
                            onClick={e => { setPlay(true) }}>
                            <i className="icon-video">
                            </i>
                        </button>
                        }
                    </div>
                }

                <Container>
                    <Row>
                        <Col>
                            <div className={`customer-wrapper`}>

                                {Module?.vid_layout_type !== "image_fixed_height" && 
                                    <div className={`video-img`}>
                                        {Module?.image?.url && renderComponent === "true" &&
                                            <ImageModule ImageSrc={Module.image} altText={Module?.title} imagetransforms={processedImages} ggfx_results={GQLPage?.ggfx_results} renderer="srcSet" imagename={imagename} strapi_id={GQLPage?.id} />  
                                        }

                                        {videoUrl && 
                                        <button className="video-wrap"
                                            onClick={e => { setPlay(true) }}>
                                            <i className="icon-video">
                                            </i>
                                        </button>
                                        }
                                    </div>
                                }
                                
                                <div className="video-content">
                                    {Module?.title && <h3>{Module?.title}</h3>}
                                    
                                    {Module?.content && 
                                        <div className="video_text"> 
                                            {Module?.read_more_content ? 
                                                <>
                                                    <ContentModule Content={Module?.content} /> 
                                                    {isReadMore ? <>
                                                            <ContentModule Content={Module?.read_more_content} /> 
                                                            <a href="javascript:;" className="btn-link" onClick={() => setReadMore(false)}>Read Less</a>
                                                        </>
                                                        :
                                                        <a href="javascript:;" className="btn-link" onClick={() => setReadMore(true)}>Read More</a>
                                                    }
                                                </>
                                                :
                                                <ContentModule Content={Module?.content} /> 
                                            }
                                            

                                        </div> 
                                    }

                                    {Module?.button_CTA?.length > 0 && 

                                        <div className={`button_cta_wrapper ${Module?.button_CTA?.length > 1 ? "btn_col" : ""}`}>
                                            {Module?.button_CTA?.length > 0 && Module?.button_CTA?.map(item =>  <CTABtnModule button_cta={item} />) }
                                        </div>
                                    }
                                    {Module?.branch_search && (
                                        <div className="customer-search-box">
                                            <span>Find your nearest branch</span>
                                            <div className="location-search-box">
                                                <input
                                                    className="form-control location-search"
                                                    placeholder="Location or postcode"
                                                    value={searchQuery}
                                                    onChange={(e) => setSearchQuery(e.target.value)}
                                                    onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                                                />
                                                <button className="search-icon" onClick={handleSearch}>
                                                    <i className="icon-search"></i> 
                                                    <span className="d-none d-xl-flex">Search</span>
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                    
                                    
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <PlayVideo
                isOpen={isPlay}
                isCloseFunction={setPlay}
                videoUrl={videoUrl}
                isAutoPlay={1}
            />
        </React.Fragment>
    );
};
export default Customer;
